// extracted by mini-css-extract-plugin
module.exports = {"p":"jg-processing_p_3RLN9"};